
import { defineComponent, PropType, computed } from 'vue'
import { MemberInAgreement } from '@/modules/agreements'
import { AgreementsRouteNames, MembersRouteNames } from '@/router/routes-names'

export default defineComponent({
    name: 'agreements-members-search-results',
    props: {
        members: {
            type: Array as PropType<MemberInAgreement[]>,
            required: true
        },
        filter: {
            type: String
        }
    },
    methods: {
        accessStatusToColor: (status: string) => {
            switch (status) {
            case 'ongoing':
                return 'positive'
            case 'cancelled':
                return 'negative'
            case 'expired':
                return 'warning'
            default:
                return 'grey'
            }
        }
    },
    async setup (props) {
        console.log('props.members', props.members)
        const groupedMembers = computed(() => {
            return props.members.reduce((grouped: { [key: string]: MemberInAgreement[] }, member: MemberInAgreement) => {
                (grouped[member.memberId] = grouped[member.memberId] || []).push(member)
                return grouped
            }, {})
        })
        return {
            groupedMembers,
            AgreementsRouteNames,
            MembersRouteNames
        }
    }
})
